import Toast from './toast';

let toastInstance;
let name = 1;
const defaultDuration = 4.5;
const prefixKey = 'notice_key_';

function getNoticeInstance() {
  toastInstance = toastInstance || Toast.newInstance();

  return toastInstance;
}

function notice(type, options) {
  const duration = options.duration === 0 ? 0 : options.duration || defaultDuration;
  const content = options.content || '';
  const noticeKey = options.name || `${prefixKey}${name}`;
  const onClose = options.onClose || function() {};

  name++;

  let instance = getNoticeInstance();

  instance.show({
    name: noticeKey,
    duration,
    content,
    onClose,
  });
}

export default {
  info(options) {
    return notice('info', options);
  },
};